import { Button } from '@material-tailwind/react/components/Button';
import { Spinner } from '@material-tailwind/react/components/Spinner';
import { Typography } from '@material-tailwind/react/components/Typography';
import { useState } from 'react';
import SchmiedeIcon from 'src/assets/icons/schmiede-thumbnail.svg';
import { ENV_VARIABLES } from 'src/common/constants';
import { RestAPIInstance } from 'src/lib/rest-api';

export function BackendUnreachableScreen() {
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      await RestAPIInstance.httpClient.get(
        `${ENV_VARIABLES.REST_API_URL}/health`,
      );
    } catch {
      // interceptor already updates the store; nothing to do on a real HTTP error
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-6 bg-white p-5">
      <img alt="Schmiede" className="h-16 w-16" src={SchmiedeIcon} />
      <div className="flex flex-col items-center gap-2 text-center">
        <Typography placeholder="" variant="h4">
          Verbindung zum Server nicht möglich
        </Typography>
        <Typography className="max-w-md text-gray-600" placeholder="">
          Der Server ist momentan nicht erreichbar. Bitte überprüfen Sie Ihre
          Internetverbindung.
        </Typography>
      </div>
      <Spinner className="h-10 w-10" />
      <Button
        className="flex items-center justify-center gap-2"
        disabled={isRetrying}
        onClick={handleRetry}
        placeholder=""
        variant="gradient"
      >
        Erneut versuchen
        {isRetrying && <Spinner className="h-4 w-4" />}
      </Button>
    </div>
  );
}
